export function isDateProperty(propertyName: string | number) {
  const paramName = `${propertyName}`;
  const paramNameInLowerCase = paramName.toLowerCase();

  return (
    (paramNameInLowerCase.includes("date") && !paramNameInLowerCase.includes("updated")) ||
    paramNameInLowerCase.includes("since") ||
    paramNameInLowerCase.includes("until") ||
    paramName.endsWith("At")
  );
}

// tslint:disable-next-line:no-identical-functions
export function isNumberProperty(propertyName: string | number) {
  const paramName = `${propertyName}`;
  const paramNameInLowerCase = paramName.toLowerCase();

  return (
    paramNameInLowerCase.includes("amount") ||
    paramNameInLowerCase.includes("price") ||
    paramNameInLowerCase.includes("symbol") ||
    paramNameInLowerCase.includes("credit") ||
    paramNameInLowerCase.includes("debit") ||
    paramName.endsWith("Sum") ||
    paramName.endsWith("Order") ||
    paramName.endsWith("Count") ||
    paramName.includes("Fee")
  );
}
